export default function TwitchLogo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.57801 1L2 3.36758V14.0188H4.59966V15.5H6.04606L7.49247 14.0188H9.8045L14.4286 9.28369V1H2.57801Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2726 8.69463L11.2481 10.7677H8.07047L6.33645 12.5434V10.7677H3.73679V2.18662H13.2726V8.69463ZM2.57801 1L2 3.36758V14.0188H4.59966V15.5H6.04606L7.49247 14.0188H9.8045L14.4286 9.28369V1H2.57801ZM6.91169 8.0999H8.06494V4.54854H6.91169V8.0999ZM10.0921 8.0999H11.2454V4.54854H10.0921V8.0999Z"
        fill="#6441A5"
        className="path-fill"
      />
    </svg>
  );
}
